// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   ALL FACILITIES — theme-aligned listing page
   ================================================================ */

.af-page {
  background: var(--bv-bg-cream);
  min-height: 60vh;
  overflow-x: clip;
  --af-sticky-top: calc(76px + var(--bv-space-4));
}

/* ---- Hero (replaces image breadcrumb banner) ---- */
.af-hero {
  position: relative;
  overflow: hidden;
  padding: clamp(1.75rem, 4vw, 3rem) 0 clamp(1.5rem, 3vw, 2.25rem);
  background: linear-gradient(
    165deg,
    var(--bv-bg) 0%,
    var(--bv-primary-50) 45%,
    var(--bv-bg-cream) 100%
  );
  border-bottom: 1px solid var(--bv-line-soft);
}

.af-hero__inner {
  position: relative;
  z-index: 1;
}

.af-hero__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: clamp(1rem, 2vw, 1.75rem);
  align-items: center;
}

.af-hero__visual {
  width: 100%;
  min-width: 0;
  line-height: 0;
  animation: bvFadeUp 0.75s var(--bv-ease-out) 0.12s both;
}

.af-hero__img {
  display: block;
  width: 100%;
  height: auto;
  max-width: none;
  object-fit: contain;
  object-position: center right;
  background: none;
  border: 0;
  box-shadow: none;
  border-radius: 0;
  vertical-align: middle;
}

.af-breadcrumb {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: var(--bv-text-sm);
}

.af-breadcrumb__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--bv-muted);
  font-weight: 500;
  transition: color var(--bv-dur) var(--bv-ease);
}
.af-breadcrumb__link:hover {
  color: var(--bv-primary-700);
}
.af-breadcrumb__link i {
  font-size: 0.75rem;
  color: var(--bv-primary);
}

.af-breadcrumb__sep {
  color: var(--bv-muted-2);
  font-size: 0.65rem;
}

.af-breadcrumb__current {
  color: var(--bv-ink);
  font-weight: 600;
}

.af-hero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  margin-bottom: var(--bv-space-4);
  animation: bvFadeUp 0.6s var(--bv-ease-out) both;
}
.af-hero__eyebrow i {
  color: var(--bv-primary);
  font-size: 0.85rem;
}

.af-hero__title {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-4xl);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.12;
  color: var(--bv-ink);
  margin: 0 0 var(--bv-space-4);
  max-width: 14ch;
  animation: bvFadeUp 0.65s var(--bv-ease-out) 0.05s both;
}

.af-hero__lede {
  font-size: var(--bv-text-lg);
  color: var(--bv-muted);
  line-height: 1.65;
  max-width: 52ch;
  margin: 0;
  animation: bvFadeUp 0.7s var(--bv-ease-out) 0.1s both;
}

/* ---- Layout: inside .bv-container--wide (theme padding) ---- */
.af-listings {
  padding-block: var(--bv-space-7) var(--bv-section-y);
}

.af-listings .bv-container--wide {
  width: 100%;
}

.af-layout {
  --af-sidebar-width: minmax(360px, 400px);
  display: grid;
  grid-template-columns: var(--af-sidebar-width) minmax(0, 1fr);
  gap: var(--bv-space-6);
  align-items: start;
  transition:
    grid-template-columns 0.42s var(--bv-ease-out),
    gap 0.42s var(--bv-ease-out);
}

.af-layout.is-filter-collapsed {
  --af-sidebar-width: 0fr;
  gap: 0;
}

.af-layout.is-filter-collapsed .af-main {
  width: 100%;
  max-width: 100%;
}

.af-layout.is-filter-collapsed .af-sidebar {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  overflow: hidden;
  min-width: 0;
}

/* ---- Left filter panel ---- */
.af-sidebar {
  position: sticky;
  top: var(--af-sticky-top);
  z-index: 2;
}

.af-sidebar__panel {
  background: var(--bv-bg);
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-xl);
  box-shadow: var(--bv-shadow-sm);
  padding: var(--bv-space-5);
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-4);
}

.af-sidebar__head {
  padding-bottom: var(--bv-space-2);
}

.af-sidebar__head-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--bv-space-3);
  margin-bottom: var(--bv-space-2);
}

.af-sidebar__collapse {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1.5px solid var(--bv-line);
  background: var(--bv-bg-soft);
  color: var(--bv-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}
.af-sidebar__collapse:hover {
  background: var(--bv-primary-50);
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-700);
  transform: translateX(-2px);
}

.af-layout.is-filter-collapsed .af-sidebar__collapse {
  display: none;
}

.af-sidebar__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--bv-text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--bv-primary-700);
  margin-bottom: var(--bv-space-2);
}
.af-sidebar__eyebrow i {
  font-size: 0.7rem;
  color: var(--bv-primary);
}

.af-sidebar__title {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-xl);
  font-weight: 800;
  color: var(--bv-ink);
  margin: 0 0 6px;
  letter-spacing: -0.02em;
}

.af-sidebar__hint {
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  margin: 0;
  line-height: 1.5;
}

.af-sidebar__filters {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: min(52vh, 420px);
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: var(--bv-primary-line) transparent;
}
.af-sidebar__filters::-webkit-scrollbar {
  width: 5px;
}
.af-sidebar__filters::-webkit-scrollbar-thumb {
  background: var(--bv-primary-line);
  border-radius: var(--bv-radius-pill);
}

.af-sidebar__filter {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: var(--bv-radius-lg);
  border: 1.5px solid transparent;
  background: var(--bv-bg-soft);
  color: var(--bv-ink-2);
  text-align: left;
  cursor: pointer;
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}
.af-sidebar__filter:hover {
  background: var(--bv-primary-50);
  border-color: var(--bv-primary-line);
  transform: translateX(3px);
}
.af-sidebar__filter.is-active {
  background: var(--bv-grad-primary);
  border-color: var(--bv-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
}
.af-sidebar__filter.is-active .af-sidebar__filter-count {
  color: rgba(255, 255, 255, 0.85);
}
.af-sidebar__filter.is-active .bv-hero__chip-icon {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(255, 255, 255, 0.5);
}

.af-sidebar__filter-icon {
  flex-shrink: 0;
  width: 44px !important;
  height: 44px !important;
}

.af-sidebar__filter-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.af-sidebar__filter-label {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 700;
  line-height: 1.25;
}

.af-sidebar__filter-count {
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
  font-weight: 500;
}

.af-sidebar__filter-check {
  flex-shrink: 0;
  font-size: 0.75rem;
  opacity: 0.95;
}

.af-sidebar__divider {
  height: 1px;
  background: var(--bv-line-soft);
  margin: var(--bv-space-1) 0;
}

.af-sidebar__sort-block {
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-3);
}

.af-sidebar__sort-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--bv-text-sm);
  font-weight: 700;
  color: var(--bv-ink);
  margin: 0;
}
.af-sidebar__sort-label i {
  color: var(--bv-primary);
}

.af-select--sidebar {
  border-radius: var(--bv-radius-lg);
}

/* ---- Main content ---- */
.af-main {
  min-width: 0;
}

.af-toolbar {
  position: sticky;
  top: var(--af-sticky-top);
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--bv-space-4);
  padding: var(--bv-space-4) var(--bv-space-5);
  margin-bottom: var(--bv-space-6);
  background: var(--bv-bg);
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-xl);
  box-shadow: var(--bv-shadow-sm);
}

.af-toolbar__left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--bv-space-4);
  min-width: 0;
  flex: 1 1 auto;
}

.af-toolbar__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--bv-space-3);
  min-width: 0;
  flex: 0 1 auto;
}

.af-toolbar__status {
  min-width: 0;
  padding-left: var(--bv-space-4);
  border-left: 1px solid var(--bv-line-soft);
}

.af-toolbar__status-line {
  display: block;
  font-size: var(--bv-text-sm);
  font-weight: 500;
  color: var(--bv-muted);
  line-height: 1.45;
  margin: 0;
}

.af-toolbar__status-line strong {
  font-family: var(--bv-font-display);
  font-weight: 800;
  color: var(--bv-ink);
}

.af-toolbar__status-line--loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.af-toolbar__status-line--muted {
  color: var(--bv-muted);
  font-weight: 600;
}

.af-toolbar__filter-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px 9px 10px;
  border-radius: var(--bv-radius-pill);
  border: 1.5px solid var(--bv-primary-line);
  background: var(--bv-grad-soft);
  color: var(--bv-primary-700);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}
.af-toolbar__filter-toggle:hover {
  border-color: var(--bv-primary);
  background: #fff;
  box-shadow: 0 8px 22px rgba(20, 184, 166, 0.14);
  transform: translateY(-1px);
}
.af-toolbar__filter-toggle.is-open {
  background: var(--bv-bg-soft);
  border-color: var(--bv-line);
  color: var(--bv-ink-2);
}
.af-toolbar__filter-toggle.is-open:hover {
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-700);
}

.af-toolbar__filter-toggle-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bv-grad-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.28);
  transition: transform var(--bv-dur) var(--bv-ease);
}
.af-toolbar__filter-toggle.is-open .af-toolbar__filter-toggle-icon {
  background: var(--bv-bg);
  color: var(--bv-primary);
  border: 1.5px solid var(--bv-primary-line);
  box-shadow: none;
}
.af-toolbar__filter-toggle:hover .af-toolbar__filter-toggle-icon {
  transform: scale(1.05);
}

.af-toolbar__filter-toggle-chev {
  font-size: 0.65rem;
  opacity: 0.75;
  margin-left: 2px;
}

.af-select-wrap--toolbar {
  min-width: 168px;
}

.af-select--toolbar {
  padding: 10px 36px 10px 14px;
  font-size: var(--bv-text-sm);
}

.af-toolbar__search {
  position: relative;
  flex: 1 1;
  min-width: 200px;
  max-width: 440px;
}

.af-toolbar__search > .fa-magnifying-glass {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--bv-primary);
  font-size: 0.9rem;
  pointer-events: none;
  z-index: 1;
}

.af-toolbar__search-input {
  width: 100%;
  padding: 12px 42px 12px 44px;
  border-radius: var(--bv-radius-pill);
  border: 1.5px solid var(--bv-line);
  background: var(--bv-bg-soft);
  color: var(--bv-ink);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 500;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease);
}
.af-toolbar__search-input::placeholder {
  color: var(--bv-muted-2);
}
.af-toolbar__search-input:focus {
  outline: none;
  border-color: var(--bv-primary);
  background: var(--bv-bg);
  box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.12);
}

.af-toolbar__search-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: var(--bv-line-soft);
  color: var(--bv-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background var(--bv-dur) var(--bv-ease), color var(--bv-dur) var(--bv-ease);
}
.af-toolbar__search-clear:hover {
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
}

.af-toolbar__sort {
  display: flex;
  align-items: center;
  gap: var(--bv-space-3);
}

.af-toolbar__sort-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--bv-text-sm);
  font-weight: 600;
  color: var(--bv-muted);
  margin: 0;
}
.af-toolbar__sort-label i {
  color: var(--bv-primary);
}

.af-select-wrap {
  position: relative;
  min-width: 200px;
}

.af-select {
  width: 100%;
  appearance: none;
  padding: 11px 40px 11px 16px;
  border-radius: var(--bv-radius-pill);
  border: 1.5px solid var(--bv-line);
  background: var(--bv-bg-soft);
  color: var(--bv-ink);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  cursor: pointer;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}
.af-select:focus {
  outline: none;
  border-color: var(--bv-primary);
  box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.12);
}

.af-select__chevron {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.7rem;
  color: var(--bv-muted);
  pointer-events: none;
}

.af-alert {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: var(--bv-space-4) var(--bv-space-5);
  border-radius: var(--bv-radius-lg);
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-weight: 500;
  margin-bottom: var(--bv-space-6);
}

/* ---- Venue grid — 2 cols with sidebar; 3 equal cols filling width when collapsed ---- */
.af-main .af-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--bv-space-5);
  width: 100%;
  align-items: stretch;
  transition: grid-template-columns 0.42s var(--bv-ease-out);
}

@media (min-width: 992px) {
  .af-main .af-grid {
    gap: var(--bv-space-5);
  }

  .af-layout.is-filter-open .af-main .af-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .af-layout.is-filter-collapsed .af-main .af-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    max-width: none;
    margin-inline: 0;
  }

  .af-venue-card__media {
    aspect-ratio: 16 / 10;
  }

  .af-venue-card__body {
    padding: var(--bv-space-4) var(--bv-space-5) var(--bv-space-4);
    gap: 9px;
  }
}

/* Medium desktop: 2-up when filters closed */
@media (min-width: 992px) and (max-width: 1100px) {
  .af-layout.is-filter-collapsed .af-main .af-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* ---- Venue cards — modern magazine style ---- */
.af-venue-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  border-radius: var(--bv-radius-2xl);
  background: var(--bv-bg);
  border: 1px solid var(--bv-line);
  overflow: hidden;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 12px 32px rgba(15, 23, 42, 0.06);
  transition:
    transform var(--bv-dur-slow) var(--bv-ease-out),
    box-shadow var(--bv-dur-slow) var(--bv-ease-out),
    border-color var(--bv-dur) var(--bv-ease);
}

.af-venue-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(
    145deg,
    rgba(20, 184, 166, 0.0) 0%,
    rgba(20, 184, 166, 0.35) 50%,
    rgba(20, 184, 166, 0.0) 100%
  );
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  opacity: 0;
  pointer-events: none;
  transition: opacity var(--bv-dur) var(--bv-ease);
  z-index: 3;
}
.af-venue-card:hover {
  transform: translateY(-8px);
  border-color: rgba(20, 184, 166, 0.35);
  box-shadow:
    0 4px 8px rgba(15, 23, 42, 0.04),
    0 28px 56px rgba(15, 23, 42, 0.14),
    0 0 0 1px rgba(20, 184, 166, 0.08);
}
.af-venue-card:hover::before {
  opacity: 1;
}

.af-venue-card__link {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: inherit;
  text-decoration: none;
}

.af-venue-card__media {
  position: relative;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: linear-gradient(135deg, var(--bv-ink) 0%, #1e3a5f 100%);
}

.af-venue-card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.65s var(--bv-ease-out), filter 0.4s var(--bv-ease);
}
.af-venue-card:hover .af-venue-card__media img {
  transform: scale(1.08);
  filter: brightness(1.05);
}

.af-venue-card__media-shine {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    125deg,
    rgba(255, 255, 255, 0.18) 0%,
    transparent 42%,
    transparent 100%
  );
  opacity: 0;
  transition: opacity var(--bv-dur) var(--bv-ease);
  pointer-events: none;
  z-index: 1;
}
.af-venue-card:hover .af-venue-card__media-shine {
  opacity: 1;
}

.af-venue-card__media-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(15, 23, 42, 0.35) 0%, transparent 28%),
    linear-gradient(0deg, rgba(15, 23, 42, 0.75) 0%, transparent 55%);
  pointer-events: none;
  z-index: 1;
}

.af-venue-card__media-top {
  position: absolute;
  top: 14px;
  left: 14px;
  right: 14px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  z-index: 2;
}

.af-venue-card__price {
  padding: 6px 12px;
  border-radius: var(--bv-radius-pill);
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(10px);
  color: #fff;
  font-family: var(--bv-font-display);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}

.af-venue-card__avail {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 11px;
  border-radius: var(--bv-radius-pill);
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(10px);
  color: var(--bv-primary-800);
  font-size: 0.68rem;
  font-weight: 700;
  font-family: var(--bv-font-display);
  margin-left: auto;
  box-shadow: var(--bv-shadow-xs);
}
.af-venue-card__avail i {
  color: var(--bv-accent-2);
  font-size: 0.65rem;
}

.af-venue-card__body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  padding: var(--bv-space-5) var(--bv-space-5) var(--bv-space-4);
  gap: 10px;
  background: linear-gradient(180deg, var(--bv-bg) 0%, var(--bv-bg-cream) 100%);
}

.af-venue-card__title {
  font-family: var(--bv-font-display);
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.03em;
  margin: 0;
  line-height: 1.2;
  transition: color var(--bv-dur) var(--bv-ease);
}
.af-venue-card:hover .af-venue-card__title {
  color: var(--bv-primary-700);
}

.af-venue-card__loc {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--bv-text-sm);
  color: var(--bv-ink-3);
  margin: 0;
  line-height: 1.35;
  font-weight: 500;
}

.af-venue-card__loc-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--bv-primary-50);
  color: var(--bv-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.7rem;
}

.af-venue-card__desc {
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  line-height: 1.55;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Hero chips on venue cards (same as homepage bv-hero__chips) */
.af-page .bv-hero__chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px 6px 6px;
  border-radius: var(--bv-radius-pill);
  background: #fff;
  border: 1px solid var(--bv-line);
  color: var(--bv-ink-2);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  transition: border-color var(--bv-dur) var(--bv-ease), box-shadow var(--bv-dur) var(--bv-ease);
}
.af-page .bv-hero__chip-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 3px;
  flex-shrink: 0;
}
.af-page .bv-hero__chip-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Service tags — same chips as homepage hero */
.af-venue-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
}

.af-venue-card__tags .bv-hero__chip {
  padding: 5px 12px 5px 5px;
  font-size: 0.72rem;
  text-transform: capitalize;
  cursor: default;
  pointer-events: none;
}

.af-venue-card__tags .bv-hero__chip-icon {
  width: 28px;
  height: 28px;
}

.af-venue-card__footer {
  margin-top: auto;
  padding-top: var(--bv-space-4);
}

.af-venue-card__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 12px 18px;
  border-radius: var(--bv-radius-lg);
  background: var(--bv-grad-primary);
  color: #fff;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 700;
  box-shadow: var(--bv-shadow-teal);
  transition:
    box-shadow var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.af-venue-card__cta-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  transition: transform var(--bv-dur) var(--bv-ease), background var(--bv-dur) var(--bv-ease);
}

.af-venue-card:hover .af-venue-card__cta {
  box-shadow: 0 18px 40px rgba(20, 184, 166, 0.38);
  transform: translateY(-2px);
}
.af-venue-card:hover .af-venue-card__cta-icon {
  background: #fff;
  color: var(--bv-primary);
  transform: translateX(4px);
}

/* ---- Skeleton loading ---- */
.af-venue-card--skeleton {
  pointer-events: none;
}
.af-venue-card--skeleton .af-skeleton--img {
  aspect-ratio: 16 / 10;
  border-radius: 0;
}
.af-skeleton {
  background: linear-gradient(
    90deg,
    var(--bv-line-soft) 0%,
    #e8eef4 50%,
    var(--bv-line-soft) 100%
  );
  background-size: 200% 100%;
  animation: afShimmer 1.4s ease-in-out infinite;
  border-radius: var(--bv-radius-sm);
}
.af-skeleton--line {
  height: 14px;
  margin: 12px var(--bv-space-5) 0;
}
.af-skeleton--title {
  height: 20px;
  width: 70%;
}
.af-skeleton--short {
  width: 45%;
  margin-bottom: var(--bv-space-5);
}

@keyframes afShimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

/* ---- Empty state ---- */
.af-empty {
  text-align: center;
  padding: var(--bv-space-12) var(--bv-space-6);
  background: var(--bv-bg);
  border-radius: var(--bv-radius-2xl);
  border: 1px dashed var(--bv-line);
  max-width: 480px;
  margin: 0 auto;
}

.af-empty__icon {
  width: 72px;
  height: 72px;
  margin: 0 auto var(--bv-space-5);
  border-radius: 50%;
  background: var(--bv-primary-50);
  color: var(--bv-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  animation: bvPulseRing 2.5s ease-out infinite;
}

.af-empty h3 {
  font-size: var(--bv-text-xl);
  margin-bottom: var(--bv-space-3);
}

.af-empty p {
  color: var(--bv-muted);
  font-size: var(--bv-text-base);
  margin-bottom: var(--bv-space-6);
  line-height: 1.6;
}

.af-sidebar__sort-block .af-select-wrap {
  width: 100%;
}

/* ================================================================
   RESPONSIVE — tablet & mobile
   ================================================================ */

/* Tablet: single column layout, 1 card per row */
@media (max-width: 991.98px) {
  .af-page {
    --af-sticky-top: calc(72px + var(--bv-space-3));
  }

  .af-hero {
    padding: 1.5rem 0 1.25rem;
  }

  .af-hero__body {
    grid-template-columns: 1fr;
    gap: var(--bv-space-6);
  }

  .af-hero__img {
    object-position: center;
  }

  .af-hero__title {
    max-width: none;
    font-size: clamp(1.65rem, 4.5vw, 2.25rem);
  }

  .af-hero__lede {
    max-width: none;
    font-size: var(--bv-text-base);
  }

  .af-listings {
    padding: var(--bv-space-5) 0 var(--bv-space-9);
  }

  .af-layout {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--bv-space-5);
    width: 100%;
    min-width: 0;
  }

  .af-layout.is-filter-collapsed {
    gap: var(--bv-space-5);
  }

  .af-layout.is-filter-collapsed .af-sidebar {
    display: none;
  }

  .af-sidebar__collapse {
    display: none;
  }

  .af-sidebar {
    position: static;
    top: auto;
    width: 100%;
    min-width: 0;
  }

  .af-toolbar {
    flex-direction: column;
    align-items: stretch;
    padding: var(--bv-space-4);
  }

  .af-toolbar__left {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: var(--bv-space-3);
  }

  .af-toolbar__filter-toggle {
    width: 100%;
    justify-content: center;
  }

  .af-toolbar__status {
    padding-left: 0;
    border-left: none;
    padding-top: var(--bv-space-2);
    border-top: 1px solid var(--bv-line-soft);
    text-align: center;
  }

  .af-toolbar__right {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .af-main {
    width: 100%;
    min-width: 0;
  }

  .af-sidebar__panel {
    padding: var(--bv-space-4);
    width: 100%;
    box-sizing: border-box;
  }

  .af-sidebar__filters {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    max-height: none;
    gap: 8px;
    padding-bottom: 6px;
    margin: 0 -2px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .af-sidebar__filters::-webkit-scrollbar {
    display: none;
  }

  .af-sidebar__filter {
    flex: 0 0 auto;
    scroll-snap-align: start;
    min-width: 0;
    max-width: 200px;
    width: auto;
    padding: 8px 12px 8px 8px;
  }

  .af-sidebar__filter:hover {
    transform: none;
  }

  .af-sidebar__filter-text {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    min-width: 0;
  }

  .af-sidebar__filter-label {
    font-size: 0.8rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }

  .af-sidebar__filter-check {
    display: none;
  }

  .af-sidebar__sort-block {
    flex-direction: column;
    align-items: stretch;
    gap: var(--bv-space-2);
  }

  .af-sidebar__sort-block .af-select-wrap {
    width: 100%;
    min-width: 0;
  }

  .af-sidebar__divider {
    display: none;
  }

  .af-sidebar__hint {
    display: none;
  }

  .af-sidebar__title {
    font-size: var(--bv-text-lg);
    margin-bottom: 0;
  }

  .af-sidebar__head {
    padding-bottom: var(--bv-space-3);
  }

  .af-main .af-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--bv-space-4);
  }

  .af-toolbar {
    border-radius: var(--bv-radius-lg);
    margin-bottom: var(--bv-space-5);
  }
}

/* Mobile */
@media (max-width: 767.98px) {
  .af-page {
    --af-sticky-top: calc(64px + var(--bv-space-2));
  }

  .af-hero {
    padding: 1.15rem 0 1rem;
  }

  .af-breadcrumb {
    margin-bottom: var(--bv-space-3);
    gap: 6px;
    font-size: var(--bv-text-xs);
  }

  .af-hero__eyebrow {
    font-size: var(--bv-text-xs);
    padding: 5px 12px;
    margin-bottom: var(--bv-space-3);
  }

  .af-hero__title {
    font-size: clamp(1.45rem, 7vw, 1.85rem);
    margin-bottom: var(--bv-space-3);
    line-height: 1.15;
  }

  .af-hero__lede {
    font-size: var(--bv-text-sm);
    line-height: 1.55;
  }

  .af-sidebar__panel {
    padding: var(--bv-space-3);
    border-radius: var(--bv-radius-lg);
  }

  .af-sidebar__filter-icon {
    width: 36px !important;
    height: 36px !important;
  }

  .af-sidebar__filter {
    padding: 7px 10px 7px 7px;
    max-width: 175px;
  }

  .af-toolbar {
    padding: var(--bv-space-3) var(--bv-space-4);
    margin-bottom: var(--bv-space-4);
    border-radius: var(--bv-radius-lg);
  }

  .af-toolbar__sort {
    width: 100%;
  }

  .af-toolbar__sort .af-select-wrap {
    flex: 1 1;
    min-width: 0;
  }

  .af-toolbar__search {
    max-width: none;
    width: 100%;
    min-width: 0;
  }

  .af-toolbar__search-input {
    font-size: 16px; /* prevents iOS zoom on focus */
    padding: 11px 40px 11px 42px;
  }

  .af-venue-card {
    border-radius: var(--bv-radius-xl);
  }

  .af-venue-card__body {
    padding: var(--bv-space-4);
    gap: 8px;
  }

  .af-venue-card__title {
    font-size: 1rem;
  }

  .af-venue-card__media {
    aspect-ratio: 16 / 10;
  }

  .af-venue-card__media-top {
    top: 10px;
    left: 10px;
    right: 10px;
  }

  .af-venue-card__price,
  .af-venue-card__avail {
    font-size: 0.65rem;
    padding: 5px 9px;
  }

  .af-venue-card__tags .bv-hero__chip {
    font-size: 0.68rem;
    padding: 4px 10px 4px 4px;
  }

  .af-venue-card__tags .bv-hero__chip-icon {
    width: 24px;
    height: 24px;
  }

  .af-venue-card__cta {
    padding: 11px 16px;
    font-size: var(--bv-text-sm);
  }

  .af-empty {
    padding: var(--bv-space-8) var(--bv-space-4);
    margin-inline: 0;
  }
}

/* Small phones */
@media (max-width: 575.98px) {
  .af-page {
    --af-sticky-top: calc(60px + 6px);
  }

  .af-sidebar__filter-count {
    display: none;
  }

  .af-sidebar__filter-label {
    max-width: 96px;
  }

  .af-sidebar__filter {
    max-width: 148px;
  }

  .af-venue-card__media-top {
    flex-wrap: wrap;
    gap: 6px;
  }

  .af-venue-card__avail {
    margin-left: 0;
    font-size: 0.6rem;
  }

  .af-venue-card__loc {
    font-size: var(--bv-text-xs);
    align-items: flex-start;
  }

  .af-venue-card__desc {
    -webkit-line-clamp: 3;
    font-size: var(--bv-text-xs);
  }

  .af-venue-card__tags {
    gap: 4px;
  }
}

/* Very narrow (320px) */
@media (max-width: 380px) {
  .af-hero__title {
    font-size: 1.35rem;
  }

  .af-sidebar__eyebrow {
    font-size: 0.65rem;
  }
}

/* Touch devices: calmer hovers */
@media (hover: none) {
  .af-venue-card:hover {
    transform: none;
  }
  .af-sidebar__filter:hover {
    transform: none;
  }
}

/* Legacy breadcrumb — hidden on this page only (other pages may still use it) */
.af-page .breadcrumb.breadcrumb-list {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/css/allFacility.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE;;;;;GAKC;EACD,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,gDAAgD;AAClD;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,qDAAqD;AACvD;;AAEA,iEAAiE;AACjE;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,6DAA6D;EAC7D,sBAAsB;EACtB,kBAAkB;EAClB;;gCAE8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;;;0CAIwC;AAC1C;AACA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mDAAmD;AACrD;AACA;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf;;;;0CAIwC;AAC1C;AACA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,4CAA4C;EAC5C,gCAAgC;EAChC,wBAAwB;EACxB,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd;;;;0CAIwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,+CAA+C;EAC/C,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,+CAA+C;EAC/C,kDAAkD;AACpD;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB;;;2CAGyC;AAC3C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,uFAAuF;AACzF;AACA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf;;2CAEyC;AAC3C;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4CAA4C;EAC5C,kCAAkC;EAClC,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,0FAA0F;AAC1F;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,0DAA0D;AAC5D;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;IAChD,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,8DAA8D;IAC9D,QAAQ;EACV;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,wBAAwB;EACxB,gCAAgC;EAChC,gBAAgB;EAChB;;sCAEoC;EACpC;;;6CAG2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ;;;;;GAKC;EAED,sEAAsE;EAEtE,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,gDAAgD;EAChD,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC;;;sCAGoC;AACtC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0EAA0E;AAC5E;AACA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,UAAU;EACV,gDAAgD;EAChD,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;qEAEmE;EACnE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,8DAA8D;EAC9D,SAAS;EACT,6EAA6E;AAC/E;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,8FAA8F;AAChG;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,WAAW;EACX,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;EACjC;;0CAEwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2FAA2F;AAC7F;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,8CAA8C;EAC9C,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,wBAAwB;EACxB,mCAAmC;EACnC,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;qEAEqE;;AAErE,iDAAiD;AACjD;EACE;IACE,+CAA+C;EACjD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,kCAAkC;IAClC,gCAAgC;EAClC;AACF;;AAEA,WAAW;AACX;EACE;IACE,+CAA+C;EACjD;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,QAAQ;IACR,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;IACvC,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,4CAA4C;IAC5C,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe,EAAE,+BAA+B;IAChD,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,WAAW;EACb;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,4CAA4C;IAC5C,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,gFAAgF;AAChF;EACE,aAAa;AACf","sourcesContent":["/* ================================================================\n   ALL FACILITIES — theme-aligned listing page\n   ================================================================ */\n\n.af-page {\n  background: var(--bv-bg-cream);\n  min-height: 60vh;\n  overflow-x: clip;\n  --af-sticky-top: calc(76px + var(--bv-space-4));\n}\n\n/* ---- Hero (replaces image breadcrumb banner) ---- */\n.af-hero {\n  position: relative;\n  overflow: hidden;\n  padding: clamp(1.75rem, 4vw, 3rem) 0 clamp(1.5rem, 3vw, 2.25rem);\n  background: linear-gradient(\n    165deg,\n    var(--bv-bg) 0%,\n    var(--bv-primary-50) 45%,\n    var(--bv-bg-cream) 100%\n  );\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n\n.af-hero__inner {\n  position: relative;\n  z-index: 1;\n}\n\n.af-hero__body {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n  gap: clamp(1rem, 2vw, 1.75rem);\n  align-items: center;\n}\n\n.af-hero__visual {\n  width: 100%;\n  min-width: 0;\n  line-height: 0;\n  animation: bvFadeUp 0.75s var(--bv-ease-out) 0.12s both;\n}\n\n.af-hero__img {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-width: none;\n  object-fit: contain;\n  object-position: center right;\n  background: none;\n  border: 0;\n  box-shadow: none;\n  border-radius: 0;\n  vertical-align: middle;\n}\n\n.af-breadcrumb {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n}\n\n.af-breadcrumb__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--bv-muted);\n  font-weight: 500;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.af-breadcrumb__link:hover {\n  color: var(--bv-primary-700);\n}\n.af-breadcrumb__link i {\n  font-size: 0.75rem;\n  color: var(--bv-primary);\n}\n\n.af-breadcrumb__sep {\n  color: var(--bv-muted-2);\n  font-size: 0.65rem;\n}\n\n.af-breadcrumb__current {\n  color: var(--bv-ink);\n  font-weight: 600;\n}\n\n.af-hero__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  margin-bottom: var(--bv-space-4);\n  animation: bvFadeUp 0.6s var(--bv-ease-out) both;\n}\n.af-hero__eyebrow i {\n  color: var(--bv-primary);\n  font-size: 0.85rem;\n}\n\n.af-hero__title {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-4xl);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.12;\n  color: var(--bv-ink);\n  margin: 0 0 var(--bv-space-4);\n  max-width: 14ch;\n  animation: bvFadeUp 0.65s var(--bv-ease-out) 0.05s both;\n}\n\n.af-hero__lede {\n  font-size: var(--bv-text-lg);\n  color: var(--bv-muted);\n  line-height: 1.65;\n  max-width: 52ch;\n  margin: 0;\n  animation: bvFadeUp 0.7s var(--bv-ease-out) 0.1s both;\n}\n\n/* ---- Layout: inside .bv-container--wide (theme padding) ---- */\n.af-listings {\n  padding-block: var(--bv-space-7) var(--bv-section-y);\n}\n\n.af-listings .bv-container--wide {\n  width: 100%;\n}\n\n.af-layout {\n  --af-sidebar-width: minmax(360px, 400px);\n  display: grid;\n  grid-template-columns: var(--af-sidebar-width) minmax(0, 1fr);\n  gap: var(--bv-space-6);\n  align-items: start;\n  transition:\n    grid-template-columns 0.42s var(--bv-ease-out),\n    gap 0.42s var(--bv-ease-out);\n}\n\n.af-layout.is-filter-collapsed {\n  --af-sidebar-width: 0fr;\n  gap: 0;\n}\n\n.af-layout.is-filter-collapsed .af-main {\n  width: 100%;\n  max-width: 100%;\n}\n\n.af-layout.is-filter-collapsed .af-sidebar {\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  overflow: hidden;\n  min-width: 0;\n}\n\n/* ---- Left filter panel ---- */\n.af-sidebar {\n  position: sticky;\n  top: var(--af-sticky-top);\n  z-index: 2;\n}\n\n.af-sidebar__panel {\n  background: var(--bv-bg);\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-xl);\n  box-shadow: var(--bv-shadow-sm);\n  padding: var(--bv-space-5);\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-4);\n}\n\n.af-sidebar__head {\n  padding-bottom: var(--bv-space-2);\n}\n\n.af-sidebar__head-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--bv-space-3);\n  margin-bottom: var(--bv-space-2);\n}\n\n.af-sidebar__collapse {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 1.5px solid var(--bv-line);\n  background: var(--bv-bg-soft);\n  color: var(--bv-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n.af-sidebar__collapse:hover {\n  background: var(--bv-primary-50);\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  transform: translateX(-2px);\n}\n\n.af-layout.is-filter-collapsed .af-sidebar__collapse {\n  display: none;\n}\n\n.af-sidebar__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--bv-primary-700);\n  margin-bottom: var(--bv-space-2);\n}\n.af-sidebar__eyebrow i {\n  font-size: 0.7rem;\n  color: var(--bv-primary);\n}\n\n.af-sidebar__title {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-xl);\n  font-weight: 800;\n  color: var(--bv-ink);\n  margin: 0 0 6px;\n  letter-spacing: -0.02em;\n}\n\n.af-sidebar__hint {\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.af-sidebar__filters {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: min(52vh, 420px);\n  overflow-y: auto;\n  padding-right: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--bv-primary-line) transparent;\n}\n.af-sidebar__filters::-webkit-scrollbar {\n  width: 5px;\n}\n.af-sidebar__filters::-webkit-scrollbar-thumb {\n  background: var(--bv-primary-line);\n  border-radius: var(--bv-radius-pill);\n}\n\n.af-sidebar__filter {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: var(--bv-radius-lg);\n  border: 1.5px solid transparent;\n  background: var(--bv-bg-soft);\n  color: var(--bv-ink-2);\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n.af-sidebar__filter:hover {\n  background: var(--bv-primary-50);\n  border-color: var(--bv-primary-line);\n  transform: translateX(3px);\n}\n.af-sidebar__filter.is-active {\n  background: var(--bv-grad-primary);\n  border-color: var(--bv-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n}\n.af-sidebar__filter.is-active .af-sidebar__filter-count {\n  color: rgba(255, 255, 255, 0.85);\n}\n.af-sidebar__filter.is-active .bv-hero__chip-icon {\n  background: rgba(255, 255, 255, 0.95);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.af-sidebar__filter-icon {\n  flex-shrink: 0;\n  width: 44px !important;\n  height: 44px !important;\n}\n\n.af-sidebar__filter-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.af-sidebar__filter-label {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.af-sidebar__filter-count {\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n  font-weight: 500;\n}\n\n.af-sidebar__filter-check {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  opacity: 0.95;\n}\n\n.af-sidebar__divider {\n  height: 1px;\n  background: var(--bv-line-soft);\n  margin: var(--bv-space-1) 0;\n}\n\n.af-sidebar__sort-block {\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-3);\n}\n\n.af-sidebar__sort-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  color: var(--bv-ink);\n  margin: 0;\n}\n.af-sidebar__sort-label i {\n  color: var(--bv-primary);\n}\n\n.af-select--sidebar {\n  border-radius: var(--bv-radius-lg);\n}\n\n/* ---- Main content ---- */\n.af-main {\n  min-width: 0;\n}\n\n.af-toolbar {\n  position: sticky;\n  top: var(--af-sticky-top);\n  z-index: 4;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--bv-space-4);\n  padding: var(--bv-space-4) var(--bv-space-5);\n  margin-bottom: var(--bv-space-6);\n  background: var(--bv-bg);\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-xl);\n  box-shadow: var(--bv-shadow-sm);\n}\n\n.af-toolbar__left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--bv-space-4);\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.af-toolbar__right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: var(--bv-space-3);\n  min-width: 0;\n  flex: 0 1 auto;\n}\n\n.af-toolbar__status {\n  min-width: 0;\n  padding-left: var(--bv-space-4);\n  border-left: 1px solid var(--bv-line-soft);\n}\n\n.af-toolbar__status-line {\n  display: block;\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  color: var(--bv-muted);\n  line-height: 1.45;\n  margin: 0;\n}\n\n.af-toolbar__status-line strong {\n  font-family: var(--bv-font-display);\n  font-weight: 800;\n  color: var(--bv-ink);\n}\n\n.af-toolbar__status-line--loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.af-toolbar__status-line--muted {\n  color: var(--bv-muted);\n  font-weight: 600;\n}\n\n.af-toolbar__filter-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 14px 9px 10px;\n  border-radius: var(--bv-radius-pill);\n  border: 1.5px solid var(--bv-primary-line);\n  background: var(--bv-grad-soft);\n  color: var(--bv-primary-700);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n.af-toolbar__filter-toggle:hover {\n  border-color: var(--bv-primary);\n  background: #fff;\n  box-shadow: 0 8px 22px rgba(20, 184, 166, 0.14);\n  transform: translateY(-1px);\n}\n.af-toolbar__filter-toggle.is-open {\n  background: var(--bv-bg-soft);\n  border-color: var(--bv-line);\n  color: var(--bv-ink-2);\n}\n.af-toolbar__filter-toggle.is-open:hover {\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-700);\n}\n\n.af-toolbar__filter-toggle-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  flex-shrink: 0;\n  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.28);\n  transition: transform var(--bv-dur) var(--bv-ease);\n}\n.af-toolbar__filter-toggle.is-open .af-toolbar__filter-toggle-icon {\n  background: var(--bv-bg);\n  color: var(--bv-primary);\n  border: 1.5px solid var(--bv-primary-line);\n  box-shadow: none;\n}\n.af-toolbar__filter-toggle:hover .af-toolbar__filter-toggle-icon {\n  transform: scale(1.05);\n}\n\n.af-toolbar__filter-toggle-chev {\n  font-size: 0.65rem;\n  opacity: 0.75;\n  margin-left: 2px;\n}\n\n.af-select-wrap--toolbar {\n  min-width: 168px;\n}\n\n.af-select--toolbar {\n  padding: 10px 36px 10px 14px;\n  font-size: var(--bv-text-sm);\n}\n\n.af-toolbar__search {\n  position: relative;\n  flex: 1;\n  min-width: 200px;\n  max-width: 440px;\n}\n\n.af-toolbar__search > .fa-magnifying-glass {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--bv-primary);\n  font-size: 0.9rem;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.af-toolbar__search-input {\n  width: 100%;\n  padding: 12px 42px 12px 44px;\n  border-radius: var(--bv-radius-pill);\n  border: 1.5px solid var(--bv-line);\n  background: var(--bv-bg-soft);\n  color: var(--bv-ink);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease);\n}\n.af-toolbar__search-input::placeholder {\n  color: var(--bv-muted-2);\n}\n.af-toolbar__search-input:focus {\n  outline: none;\n  border-color: var(--bv-primary);\n  background: var(--bv-bg);\n  box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.12);\n}\n\n.af-toolbar__search-clear {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 50%;\n  background: var(--bv-line-soft);\n  color: var(--bv-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: background var(--bv-dur) var(--bv-ease), color var(--bv-dur) var(--bv-ease);\n}\n.af-toolbar__search-clear:hover {\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n}\n\n.af-toolbar__sort {\n  display: flex;\n  align-items: center;\n  gap: var(--bv-space-3);\n}\n\n.af-toolbar__sort-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  color: var(--bv-muted);\n  margin: 0;\n}\n.af-toolbar__sort-label i {\n  color: var(--bv-primary);\n}\n\n.af-select-wrap {\n  position: relative;\n  min-width: 200px;\n}\n\n.af-select {\n  width: 100%;\n  appearance: none;\n  padding: 11px 40px 11px 16px;\n  border-radius: var(--bv-radius-pill);\n  border: 1.5px solid var(--bv-line);\n  background: var(--bv-bg-soft);\n  color: var(--bv-ink);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n.af-select:focus {\n  outline: none;\n  border-color: var(--bv-primary);\n  box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.12);\n}\n\n.af-select__chevron {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.7rem;\n  color: var(--bv-muted);\n  pointer-events: none;\n}\n\n.af-alert {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: var(--bv-space-4) var(--bv-space-5);\n  border-radius: var(--bv-radius-lg);\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n  font-weight: 500;\n  margin-bottom: var(--bv-space-6);\n}\n\n/* ---- Venue grid — 2 cols with sidebar; 3 equal cols filling width when collapsed ---- */\n.af-main .af-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: var(--bv-space-5);\n  width: 100%;\n  align-items: stretch;\n  transition: grid-template-columns 0.42s var(--bv-ease-out);\n}\n\n@media (min-width: 992px) {\n  .af-main .af-grid {\n    gap: var(--bv-space-5);\n  }\n\n  .af-layout.is-filter-open .af-main .af-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .af-layout.is-filter-collapsed .af-main .af-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    width: 100%;\n    max-width: none;\n    margin-inline: 0;\n  }\n\n  .af-venue-card__media {\n    aspect-ratio: 16 / 10;\n  }\n\n  .af-venue-card__body {\n    padding: var(--bv-space-4) var(--bv-space-5) var(--bv-space-4);\n    gap: 9px;\n  }\n}\n\n/* Medium desktop: 2-up when filters closed */\n@media (min-width: 992px) and (max-width: 1100px) {\n  .af-layout.is-filter-collapsed .af-main .af-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n/* ---- Venue cards — modern magazine style ---- */\n.af-venue-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: 100%;\n  border-radius: var(--bv-radius-2xl);\n  background: var(--bv-bg);\n  border: 1px solid var(--bv-line);\n  overflow: hidden;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 12px 32px rgba(15, 23, 42, 0.06);\n  transition:\n    transform var(--bv-dur-slow) var(--bv-ease-out),\n    box-shadow var(--bv-dur-slow) var(--bv-ease-out),\n    border-color var(--bv-dur) var(--bv-ease);\n}\n\n.af-venue-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  padding: 1px;\n  background: linear-gradient(\n    145deg,\n    rgba(20, 184, 166, 0.0) 0%,\n    rgba(20, 184, 166, 0.35) 50%,\n    rgba(20, 184, 166, 0.0) 100%\n  );\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity var(--bv-dur) var(--bv-ease);\n  z-index: 3;\n}\n.af-venue-card:hover {\n  transform: translateY(-8px);\n  border-color: rgba(20, 184, 166, 0.35);\n  box-shadow:\n    0 4px 8px rgba(15, 23, 42, 0.04),\n    0 28px 56px rgba(15, 23, 42, 0.14),\n    0 0 0 1px rgba(20, 184, 166, 0.08);\n}\n.af-venue-card:hover::before {\n  opacity: 1;\n}\n\n.af-venue-card__link {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  color: inherit;\n  text-decoration: none;\n}\n\n.af-venue-card__media {\n  position: relative;\n  aspect-ratio: 16 / 10;\n  overflow: hidden;\n  background: linear-gradient(135deg, var(--bv-ink) 0%, #1e3a5f 100%);\n}\n\n.af-venue-card__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.65s var(--bv-ease-out), filter 0.4s var(--bv-ease);\n}\n.af-venue-card:hover .af-venue-card__media img {\n  transform: scale(1.08);\n  filter: brightness(1.05);\n}\n\n.af-venue-card__media-shine {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    125deg,\n    rgba(255, 255, 255, 0.18) 0%,\n    transparent 42%,\n    transparent 100%\n  );\n  opacity: 0;\n  transition: opacity var(--bv-dur) var(--bv-ease);\n  pointer-events: none;\n  z-index: 1;\n}\n.af-venue-card:hover .af-venue-card__media-shine {\n  opacity: 1;\n}\n\n.af-venue-card__media-overlay {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(180deg, rgba(15, 23, 42, 0.35) 0%, transparent 28%),\n    linear-gradient(0deg, rgba(15, 23, 42, 0.75) 0%, transparent 55%);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.af-venue-card__media-top {\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  right: 14px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  z-index: 2;\n}\n\n.af-venue-card__price {\n  padding: 6px 12px;\n  border-radius: var(--bv-radius-pill);\n  background: rgba(15, 23, 42, 0.72);\n  backdrop-filter: blur(10px);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n}\n\n.af-venue-card__avail {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 11px;\n  border-radius: var(--bv-radius-pill);\n  background: rgba(255, 255, 255, 0.94);\n  backdrop-filter: blur(10px);\n  color: var(--bv-primary-800);\n  font-size: 0.68rem;\n  font-weight: 700;\n  font-family: var(--bv-font-display);\n  margin-left: auto;\n  box-shadow: var(--bv-shadow-xs);\n}\n.af-venue-card__avail i {\n  color: var(--bv-accent-2);\n  font-size: 0.65rem;\n}\n\n.af-venue-card__body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: var(--bv-space-5) var(--bv-space-5) var(--bv-space-4);\n  gap: 10px;\n  background: linear-gradient(180deg, var(--bv-bg) 0%, var(--bv-bg-cream) 100%);\n}\n\n.af-venue-card__title {\n  font-family: var(--bv-font-display);\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.03em;\n  margin: 0;\n  line-height: 1.2;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.af-venue-card:hover .af-venue-card__title {\n  color: var(--bv-primary-700);\n}\n\n.af-venue-card__loc {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-ink-3);\n  margin: 0;\n  line-height: 1.35;\n  font-weight: 500;\n}\n\n.af-venue-card__loc-icon {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--bv-primary-50);\n  color: var(--bv-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 0.7rem;\n}\n\n.af-venue-card__desc {\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  line-height: 1.55;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Hero chips on venue cards (same as homepage bv-hero__chips) */\n.af-page .bv-hero__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px 6px 6px;\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  color: var(--bv-ink-2);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  transition: border-color var(--bv-dur) var(--bv-ease), box-shadow var(--bv-dur) var(--bv-ease);\n}\n.af-page .bv-hero__chip-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  padding: 3px;\n  flex-shrink: 0;\n}\n.af-page .bv-hero__chip-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/* Service tags — same chips as homepage hero */\n.af-venue-card__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 2px;\n}\n\n.af-venue-card__tags .bv-hero__chip {\n  padding: 5px 12px 5px 5px;\n  font-size: 0.72rem;\n  text-transform: capitalize;\n  cursor: default;\n  pointer-events: none;\n}\n\n.af-venue-card__tags .bv-hero__chip-icon {\n  width: 28px;\n  height: 28px;\n}\n\n.af-venue-card__footer {\n  margin-top: auto;\n  padding-top: var(--bv-space-4);\n}\n\n.af-venue-card__cta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 12px 18px;\n  border-radius: var(--bv-radius-lg);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  box-shadow: var(--bv-shadow-teal);\n  transition:\n    box-shadow var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.af-venue-card__cta-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.25);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  transition: transform var(--bv-dur) var(--bv-ease), background var(--bv-dur) var(--bv-ease);\n}\n\n.af-venue-card:hover .af-venue-card__cta {\n  box-shadow: 0 18px 40px rgba(20, 184, 166, 0.38);\n  transform: translateY(-2px);\n}\n.af-venue-card:hover .af-venue-card__cta-icon {\n  background: #fff;\n  color: var(--bv-primary);\n  transform: translateX(4px);\n}\n\n/* ---- Skeleton loading ---- */\n.af-venue-card--skeleton {\n  pointer-events: none;\n}\n.af-venue-card--skeleton .af-skeleton--img {\n  aspect-ratio: 16 / 10;\n  border-radius: 0;\n}\n.af-skeleton {\n  background: linear-gradient(\n    90deg,\n    var(--bv-line-soft) 0%,\n    #e8eef4 50%,\n    var(--bv-line-soft) 100%\n  );\n  background-size: 200% 100%;\n  animation: afShimmer 1.4s ease-in-out infinite;\n  border-radius: var(--bv-radius-sm);\n}\n.af-skeleton--line {\n  height: 14px;\n  margin: 12px var(--bv-space-5) 0;\n}\n.af-skeleton--title {\n  height: 20px;\n  width: 70%;\n}\n.af-skeleton--short {\n  width: 45%;\n  margin-bottom: var(--bv-space-5);\n}\n\n@keyframes afShimmer {\n  0% { background-position: 100% 0; }\n  100% { background-position: -100% 0; }\n}\n\n/* ---- Empty state ---- */\n.af-empty {\n  text-align: center;\n  padding: var(--bv-space-12) var(--bv-space-6);\n  background: var(--bv-bg);\n  border-radius: var(--bv-radius-2xl);\n  border: 1px dashed var(--bv-line);\n  max-width: 480px;\n  margin: 0 auto;\n}\n\n.af-empty__icon {\n  width: 72px;\n  height: 72px;\n  margin: 0 auto var(--bv-space-5);\n  border-radius: 50%;\n  background: var(--bv-primary-50);\n  color: var(--bv-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.75rem;\n  animation: bvPulseRing 2.5s ease-out infinite;\n}\n\n.af-empty h3 {\n  font-size: var(--bv-text-xl);\n  margin-bottom: var(--bv-space-3);\n}\n\n.af-empty p {\n  color: var(--bv-muted);\n  font-size: var(--bv-text-base);\n  margin-bottom: var(--bv-space-6);\n  line-height: 1.6;\n}\n\n.af-sidebar__sort-block .af-select-wrap {\n  width: 100%;\n}\n\n/* ================================================================\n   RESPONSIVE — tablet & mobile\n   ================================================================ */\n\n/* Tablet: single column layout, 1 card per row */\n@media (max-width: 991.98px) {\n  .af-page {\n    --af-sticky-top: calc(72px + var(--bv-space-3));\n  }\n\n  .af-hero {\n    padding: 1.5rem 0 1.25rem;\n  }\n\n  .af-hero__body {\n    grid-template-columns: 1fr;\n    gap: var(--bv-space-6);\n  }\n\n  .af-hero__img {\n    object-position: center;\n  }\n\n  .af-hero__title {\n    max-width: none;\n    font-size: clamp(1.65rem, 4.5vw, 2.25rem);\n  }\n\n  .af-hero__lede {\n    max-width: none;\n    font-size: var(--bv-text-base);\n  }\n\n  .af-listings {\n    padding: var(--bv-space-5) 0 var(--bv-space-9);\n  }\n\n  .af-layout {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--bv-space-5);\n    width: 100%;\n    min-width: 0;\n  }\n\n  .af-layout.is-filter-collapsed {\n    gap: var(--bv-space-5);\n  }\n\n  .af-layout.is-filter-collapsed .af-sidebar {\n    display: none;\n  }\n\n  .af-sidebar__collapse {\n    display: none;\n  }\n\n  .af-sidebar {\n    position: static;\n    top: auto;\n    width: 100%;\n    min-width: 0;\n  }\n\n  .af-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    padding: var(--bv-space-4);\n  }\n\n  .af-toolbar__left {\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--bv-space-3);\n  }\n\n  .af-toolbar__filter-toggle {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .af-toolbar__status {\n    padding-left: 0;\n    border-left: none;\n    padding-top: var(--bv-space-2);\n    border-top: 1px solid var(--bv-line-soft);\n    text-align: center;\n  }\n\n  .af-toolbar__right {\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .af-main {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .af-sidebar__panel {\n    padding: var(--bv-space-4);\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .af-sidebar__filters {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    max-height: none;\n    gap: 8px;\n    padding-bottom: 6px;\n    margin: 0 -2px;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n  .af-sidebar__filters::-webkit-scrollbar {\n    display: none;\n  }\n\n  .af-sidebar__filter {\n    flex: 0 0 auto;\n    scroll-snap-align: start;\n    min-width: 0;\n    max-width: 200px;\n    width: auto;\n    padding: 8px 12px 8px 8px;\n  }\n\n  .af-sidebar__filter:hover {\n    transform: none;\n  }\n\n  .af-sidebar__filter-text {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  .af-sidebar__filter-label {\n    font-size: 0.8rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n  }\n\n  .af-sidebar__filter-check {\n    display: none;\n  }\n\n  .af-sidebar__sort-block {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--bv-space-2);\n  }\n\n  .af-sidebar__sort-block .af-select-wrap {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .af-sidebar__divider {\n    display: none;\n  }\n\n  .af-sidebar__hint {\n    display: none;\n  }\n\n  .af-sidebar__title {\n    font-size: var(--bv-text-lg);\n    margin-bottom: 0;\n  }\n\n  .af-sidebar__head {\n    padding-bottom: var(--bv-space-3);\n  }\n\n  .af-main .af-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--bv-space-4);\n  }\n\n  .af-toolbar {\n    border-radius: var(--bv-radius-lg);\n    margin-bottom: var(--bv-space-5);\n  }\n}\n\n/* Mobile */\n@media (max-width: 767.98px) {\n  .af-page {\n    --af-sticky-top: calc(64px + var(--bv-space-2));\n  }\n\n  .af-hero {\n    padding: 1.15rem 0 1rem;\n  }\n\n  .af-breadcrumb {\n    margin-bottom: var(--bv-space-3);\n    gap: 6px;\n    font-size: var(--bv-text-xs);\n  }\n\n  .af-hero__eyebrow {\n    font-size: var(--bv-text-xs);\n    padding: 5px 12px;\n    margin-bottom: var(--bv-space-3);\n  }\n\n  .af-hero__title {\n    font-size: clamp(1.45rem, 7vw, 1.85rem);\n    margin-bottom: var(--bv-space-3);\n    line-height: 1.15;\n  }\n\n  .af-hero__lede {\n    font-size: var(--bv-text-sm);\n    line-height: 1.55;\n  }\n\n  .af-sidebar__panel {\n    padding: var(--bv-space-3);\n    border-radius: var(--bv-radius-lg);\n  }\n\n  .af-sidebar__filter-icon {\n    width: 36px !important;\n    height: 36px !important;\n  }\n\n  .af-sidebar__filter {\n    padding: 7px 10px 7px 7px;\n    max-width: 175px;\n  }\n\n  .af-toolbar {\n    padding: var(--bv-space-3) var(--bv-space-4);\n    margin-bottom: var(--bv-space-4);\n    border-radius: var(--bv-radius-lg);\n  }\n\n  .af-toolbar__sort {\n    width: 100%;\n  }\n\n  .af-toolbar__sort .af-select-wrap {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .af-toolbar__search {\n    max-width: none;\n    width: 100%;\n    min-width: 0;\n  }\n\n  .af-toolbar__search-input {\n    font-size: 16px; /* prevents iOS zoom on focus */\n    padding: 11px 40px 11px 42px;\n  }\n\n  .af-venue-card {\n    border-radius: var(--bv-radius-xl);\n  }\n\n  .af-venue-card__body {\n    padding: var(--bv-space-4);\n    gap: 8px;\n  }\n\n  .af-venue-card__title {\n    font-size: 1rem;\n  }\n\n  .af-venue-card__media {\n    aspect-ratio: 16 / 10;\n  }\n\n  .af-venue-card__media-top {\n    top: 10px;\n    left: 10px;\n    right: 10px;\n  }\n\n  .af-venue-card__price,\n  .af-venue-card__avail {\n    font-size: 0.65rem;\n    padding: 5px 9px;\n  }\n\n  .af-venue-card__tags .bv-hero__chip {\n    font-size: 0.68rem;\n    padding: 4px 10px 4px 4px;\n  }\n\n  .af-venue-card__tags .bv-hero__chip-icon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .af-venue-card__cta {\n    padding: 11px 16px;\n    font-size: var(--bv-text-sm);\n  }\n\n  .af-empty {\n    padding: var(--bv-space-8) var(--bv-space-4);\n    margin-inline: 0;\n  }\n}\n\n/* Small phones */\n@media (max-width: 575.98px) {\n  .af-page {\n    --af-sticky-top: calc(60px + 6px);\n  }\n\n  .af-sidebar__filter-count {\n    display: none;\n  }\n\n  .af-sidebar__filter-label {\n    max-width: 96px;\n  }\n\n  .af-sidebar__filter {\n    max-width: 148px;\n  }\n\n  .af-venue-card__media-top {\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  .af-venue-card__avail {\n    margin-left: 0;\n    font-size: 0.6rem;\n  }\n\n  .af-venue-card__loc {\n    font-size: var(--bv-text-xs);\n    align-items: flex-start;\n  }\n\n  .af-venue-card__desc {\n    -webkit-line-clamp: 3;\n    font-size: var(--bv-text-xs);\n  }\n\n  .af-venue-card__tags {\n    gap: 4px;\n  }\n}\n\n/* Very narrow (320px) */\n@media (max-width: 380px) {\n  .af-hero__title {\n    font-size: 1.35rem;\n  }\n\n  .af-sidebar__eyebrow {\n    font-size: 0.65rem;\n  }\n}\n\n/* Touch devices: calmer hovers */\n@media (hover: none) {\n  .af-venue-card:hover {\n    transform: none;\n  }\n  .af-sidebar__filter:hover {\n    transform: none;\n  }\n}\n\n/* Legacy breadcrumb — hidden on this page only (other pages may still use it) */\n.af-page .breadcrumb.breadcrumb-list {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
